<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <div class="inner">
      <add-button v-if="$_createActionAllowed" :title="'Přidat inicializační proces zařízení' | translate" route-name="initialProcessSetupNew"></add-button>
      <h1 v-translate>Inicializační proces zařízení</h1>
    </div>
    <div class="inner_white">
      <div class="filter">
        <div class="field_left">
          <select-box
              id="devicetype"
              :options="deviceTypeOptions"
              v-model="formFields.id_device_type"
              ref="devicetyperef"
          >
            <translate class="translate">Typ zařízení</translate>
          </select-box>
        </div>
        <div class="field_right">
          <select-box
              id="brand"
              :options="brandOptions"
              v-model="formFields.id_brand"
              ref="brandref"
          >
            <translate class="translate">Brand</translate>
          </select-box>
        </div>
        <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset"
           :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
      </div>

      <div class="scroll-wrapper">
        <div class="table_overflow" id="contentBox" data-table-id="initial-process-setup">
          <table class="vypis vypis_detail">
            <thead>
            <tr v-if="entities.length > 0">
              <th class="no_padding drag_drop"></th>
              <th class="no_padding checkbox"></th>
              <sorting-table-title
                  v-for="title in tableTitles"
                  :key="title.key"
                  :column="title.column"
                  :sort="getActiveSort(title.column)"
                  @changeSorting="changeSorting"
              >{{ title.name }}
              </sorting-table-title>
              <th class="no_padding edit"/>
            </tr>
            </thead>
            <initial-process-setup-row
                v-for="entity in entities"
                :entity="entity"
                :key="entity.id"
                :selectedEntities="selectedEntities"
                @input="select"
                @delete-initial-process-setup="deleteEntity"
                :ref="'initial-process-setup-row-ref-'+entity.id"
            ></initial-process-setup-row>
            <tr v-if="entities.length === 0">
                 <td colspan="8">{{ $gettext('Nebyly nalezeny žádné inicializační procesy zařízení.') }}</td>
            </tr>
          </table>
        </div>
      </div>
      <list-action-line
          :entities="entities"
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="totalCount"
          table-id="initial-process-setup"
          @limit="setLimit"
          @offset="setOffset"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          @select-all="toggleSelectAll"
          @run-multiple-action="runMultipleAction"
          ref="action_line"
      ></list-action-line>
    </div>
  </div>
</template>

<script>
import listActions from "../../mixins/list-actions";
import InitialProcessSetupRow from "./InitialProcessSetupRow.vue";
import initialProcessSetup from "./mixins/InitialProcessSetup";

export default {
  name: "InitialProcessSetupList",
  components: {InitialProcessSetupRow},
  mixins: [listActions, initialProcessSetup],
  data() {
    return {
      moduleName: 'initialProcessSetup',
      formFields: {
        id_device_type: null,
        id_brand: null,
        sort: {
          column: 'sDeviceType',
          direction: 'asc',
        }
      },
    }
  },
  created(InitialProcessSetupService, DeviceTypeService, BrandService) {
    this.entityService = InitialProcessSetupService;
    this.deviceTypeService = DeviceTypeService;
    this.brandService = BrandService;
    this.createdInit();
    this.getBrands();
    this.getDeviceTypes();
  },
  computed: {
    tableTitles() {
      return [
        {key: 1, name: this.$gettext('Typ zařízení'), column: 'sDeviceTypeName'},
        {key: 2, name: this.$gettext('Brand'), column: 'sBrandName'},
        {key: 3, name: this.$gettext('Vytvořeno'), column: 'sDateCreated'},
        {key: 4, name: this.$gettext('Upraveno'), column: 'sDateUpdated'},
      ]
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
      ]
    },
    csvHeaders(){
      return this.getCsvHeaderFromSortingTableTitle(this.tableTitles)
    },
  },
  methods: {
    loadAdditionalDefaults() {
      let anyChanges = false
      if (this.loadDefaultByKey('id_device_type')) {
        anyChanges = true
      }
      if (this.loadDefaultByKey('id_brand')
      ) {
        anyChanges = true
      }
      return anyChanges
    },
    saveFilterValues() {
      this.setUserSetting('id_device_type', this.formFields.id_device_type);
      this.setUserSetting('id_brand', this.formFields.id_brand);
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/initialProcessSetup/InitialProcessSetupList.vue